import { createStaticRanges } from "react-date-range";
import { startOfDay, endOfDay, addDays } from "date-fns";

export const staticRanges = createStaticRanges([
  {
    label: "Today",
    range: () => ({
      startDate: startOfDay(new Date()),
      endDate: endOfDay(new Date()),
    }),
  },
  {
    label: "Yesterday",
    range: () => ({
      startDate: startOfDay(addDays(new Date(), -1)),
      endDate: endOfDay(addDays(new Date(), -1)),
    }),
  },
  {
    label: "Last 7 Days",
    range: () => ({
      startDate: startOfDay(addDays(new Date(), -7)),
      endDate: endOfDay(new Date()),
    }),
  },
  {
    label: "Last 30 Days",
    range: () => ({
      startDate: startOfDay(addDays(new Date(), -30)),
      endDate: endOfDay(new Date()),
    }),
  },
]);
